import React from 'react';
import { useAppSelector } from '../../hooks/redux';
import config from '../../../app/config';
import {
  isTestingPhaseAgent,
  getTestingPhaseConfig,
  DEFAULT_TESTING_MESSAGE,
} from '../../../config/testingPhaseAgents';
import {
  AgentWelcome as AgentWelcome__Root,
  AgentWelcome__Inner,
  AgentWelcome__Logo,
  AgentWelcome__Title,
  AgentWelcome__Subtitle,
  AgentWelcome__Suggestions,
  AgentWelcome__SuggestionCard,
  AgentWelcome__SuggestionIcon,
  AgentWelcome__SuggestionContent,
  AgentWelcome__SuggestionTitle,
  AgentWelcome__GetStartedText,
  AgentWelcome__TestingRibbon,
  AgentWelcome__TestingRibbonIcon,
  AgentWelcome__TestingRibbonText,
} from './AgentWelcome.styles';

export interface AgentWelcomeProps {
  onSuggestionClick: (suggestion: string) => void;
}

export const AgentWelcome: React.FC<AgentWelcomeProps> = ({ onSuggestionClick }) => {
  const activeAgent = useAppSelector((state) => state.agent.activeAgent);

  const suggestions = activeAgent?.suggestions ?? [];

  const showTestingBanner =
    config.isProd && activeAgent != null && isTestingPhaseAgent(activeAgent.name);

  const testingMessage =
    (activeAgent && getTestingPhaseConfig(activeAgent.name)?.message) ??
    DEFAULT_TESTING_MESSAGE;

  return (
    <AgentWelcome__Root>
      <AgentWelcome__Inner>

      {showTestingBanner && (
        <AgentWelcome__TestingRibbon>
          <AgentWelcome__TestingRibbonIcon>⚠️</AgentWelcome__TestingRibbonIcon>
          <AgentWelcome__TestingRibbonText>
            <strong>Testing phase — restricted access.</strong> {testingMessage}
          </AgentWelcome__TestingRibbonText>
        </AgentWelcome__TestingRibbon>
      )}

      <AgentWelcome__Logo src="/images/Grundfos_Logo-Symbol_Blue_SCREEN.svg" alt="Grundfos" />

      <AgentWelcome__Title>
        {activeAgent?.name ?? 'Welcome'}
      </AgentWelcome__Title>

      <AgentWelcome__Subtitle>
        {activeAgent?.description ?? 'Select an agent to get started.'}
      </AgentWelcome__Subtitle>

      {suggestions.length > 0 && (
        <AgentWelcome__Suggestions>
          {suggestions.map((suggestion, index) => (
            <AgentWelcome__SuggestionCard
              key={index}
              onClick={() => onSuggestionClick(suggestion.title)}
            >
              <AgentWelcome__SuggestionIcon>
                {suggestion.icon}
              </AgentWelcome__SuggestionIcon>
              <AgentWelcome__SuggestionContent>
                <AgentWelcome__SuggestionTitle>{suggestion.title}</AgentWelcome__SuggestionTitle>
              </AgentWelcome__SuggestionContent>
            </AgentWelcome__SuggestionCard>
          ))}
        </AgentWelcome__Suggestions>
      )}

      <AgentWelcome__GetStartedText>
        Click on a suggestion above or type your question in the input below
      </AgentWelcome__GetStartedText>
      </AgentWelcome__Inner>
    </AgentWelcome__Root>
  );
};
